<template>
    <div
            class="bg-white shadow-sm py-3 my-2"
            id="access_token_page"
            style="border-radius: 10px"
    >
        <div class="px-3">
            <div v-if="data_loaded">
                <div class="w-100" v-if="has_token">
                    <label for="access_token">توکن دسترسی به وب سرویس</label>
                    <textarea class="form-control" id="access_token" style="direction: ltr" type="text"
                              v-model="access_token">
                    </textarea>
                </div>
                <div v-else>
                    <button @click="generateAccessToken()" class="btn btn-success" type="button">
                        <span>ایجاد توکن دسترسی به وب سرویس</span>
                    </button>
                </div>
            </div>
            <div v-else>
                <div class="p-3 text-white-in-dark-mode" style="background-color: transparent;">
                    <div class="spinner-border text-success" role="status"></div>
                    <span class="p-2">لطفا صبر کنید</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {userService} from "@/common/api.service";

    export default {
        data() {
            return {
                data_loaded: false,
                has_token: false,
                access_token: '',
            };
        },
        methods: {
            generateAccessToken() {
                userService.generateAccessToken().then(res => {
                    this.access_token = res.data.data.access_token;
                    this.has_token = res.data.data.has_token;
                });
            },
        },
        mounted() {
            userService.fetchAccessToken().then(res => {
                this.access_token = res.data.data.access_token;
                this.has_token = res.data.data.has_token;
                this.data_loaded = true;
            });
        },
    }
</script>
